<template>
  <div style="display: inline-block">
    <slot></slot>
    <ConfirmDialog
      :dialogShow="dialogShow"
      title="审批通过"
      :showFooter="true"
      :width="800"
      @updateDialogShow="updateDialogShow"
      @confirm="confirm"
    >
      请确认是否审批通过
    </ConfirmDialog>
  </div>
</template>
<script>
import ConfirmDialog from "@/components/ConfirmDialog";
export default {
  components: {
    ConfirmDialog,
  },
  methods: {
    openDialog() {
      this.dialogShow = true;
    },
    closeDialog() {
      this.dialogShow = false;
    },
    updateDialogShow(vis) {
      this.dialogShow = vis;
    },
    confirm() {
      this.$emit("confirm");
    },
  },
  data() {
    return {
      dialogShow: false,
    };
  },
};
</script>
<style scoped>
</style>